import React from 'react'
import {connect} from 'react-redux'
import {findStations} from '../../actions/api'

import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import RoomIcon from '@mui/icons-material/Room';

import {Box} from "@mui/material";
import ViewerContainer from "../viewers/viewer-container";
import i18n from "../../../i18nSetup";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import {calcRemainingHeight, setMainPanelContent, setViewedStop} from "../../actions/ui";


function StationsSearchTab(props) {

    const {stations, locale} = props;
    const [textFieldValue, setValue] = React.useState(null);

    const handleChangeText = (e) => {
        setValue(e.target.value);
        if (e.target.value) {
            props.findStations(e.target.value, locale)
        }
    }

    const keyPress = (e) => {
        if (e.keyCode === 13) {
            if (e.target.value) {
                props.findStations(e.target.value, locale)
            }
        }
    }

    const viewStop = (stopId) => {
        props.setMainPanelContent(null)
        props.setViewedStop({stopId})
    }
    return (
        <ViewerContainer>
            <div>
                <Input placeholder={i18n.t('stopCodeOrName')}
                       inputProps={{'aria-label': 'description', 'maxLength': '40'}} fullWidth
                       startAdornment={
                           <InputAdornment position="start">
                               <RoomIcon fontSize={"small"}/>
                           </InputAdornment>
                       } onChange={handleChangeText} onKeyDown={keyPress}/>
                {
                    (stations && textFieldValue) && <Box id={'stops-list-result'} mt={4}>
                        <List sx={{overflow: 'auto', maxHeight: calcRemainingHeight('stops-list-result')}}>
                            {stations.map((station, index) => {

                                return (
                                    <div key={index + "_" + station.stop_id}>
                                        <ListItem button onClick={()=>{viewStop(station.id)}}>
                                            <ListItemText primary={station.name} secondary={(station.code ? ('#' + station.code + ' | ') : '') + (station.formatted_address || "") }/>
                                        </ListItem>
                                        <Divider />
                                    </div>
                                )
                            })}
                        </List>
                    </Box>
                }
            </div>
        </ViewerContainer>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        stations: state.otp.transitIndex.stations,
        locale: state.otp.currentQuery.locale
    }
}

const mapDispatchToProps = {
    findStations,
    setMainPanelContent,
    setViewedStop
}
export default connect(mapStateToProps, mapDispatchToProps)(StationsSearchTab)